module.exports = __webpack_public_path__ + "static/media/Winnie Nwagi - Matala.9947c66e.mp3";